import React from 'react';
import ArticleSection from './ArticleSection.js';
import copy from '../copy/ArticleOneCopy.js';
import Button from './Button';

import '../stylesheets/A.scss';

function A() {
  return (
    <article className="a">
      <section className="top-section">
        <h1>This is your brain on wealth</h1>
        <h2>How understanding the psychology of wealth can help you scale the happiness pyramid</h2>
      </section>
      <ArticleSection copy={copy} sectionNumber={0.5} />
      <ArticleSection copy={copy} sectionNumber={1} />
      <ArticleSection copy={copy} sectionNumber={2} />
      <ArticleSection copy={copy} sectionNumber={3} />
      <ArticleSection copy={copy} sectionNumber={4} />
      <Button
        message={'Get Started'}
        link={
          'https://www.johnhancock.com/individual/products-and-services/planning-and-advice.html?cid=US_JH_BR_DI_CNN_ContentPartnership_Advice_GA_CS_BA_DP_SP_DE_00_AWCTR_1x1_20191119_GetStarted_PsychologyofWealth;260654831'
        }
      />
    </article>
  );
}

export default A;
